import * as React from 'react';
import { IControlError, IControlSchema } from '../../Controls';
import {
  Component,
  I18NString,
  isNullOrEmpty,
  getRandomKey,
} from '../../Utils';
import { IDispatcher } from '../extensions/Dispatcher';
import Field from '../Field';
import { isUndefined } from 'lodash';
import Alert from './Alert';

interface IRadiobuttonSchema extends IControlSchema {
  value?: any;
  options: Array<IRadiobuttonOption>;
  disabled?: boolean;
  description: I18NString;
  defaultValue?: any;
}

interface IRadiobuttonOption {
  label: string;
  name: string;
}

interface IRadiobuttonProps {
  schema: IRadiobuttonSchema;
  dispatcher?: IDispatcher;
  error: IControlError | undefined;
  visited: boolean;
}

interface State {
  value: any;
  isOpen: boolean;
}

class Radiobutton extends Component<IRadiobuttonProps, State> {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
    this.onOpenHelp = this.onOpenHelp.bind(this);
    this.state = {
      value: null,
      isOpen: false,
    };
  }

  onClick(e: any) {
    const { attributes } = e.target,
      value = attributes.getNamedItem('data-value').value;
    this.setState({
      value,
    });
    this.props.dispatcher.onBlur(this.props.schema.id, value, true, undefined);
  }

  componentDidMount() {
    const { value, defaultValue } = this.props.schema;
    if (!isUndefined(value)) {
      this.setState({
        value,
      });
    } else if (defaultValue) {
      this.setState({ value: defaultValue });
    }
    if (
      typeof this.props.schema.extra !== 'undefined' &&
      this.props.schema.extra.showHelp
    ) {
      this.setState({ isOpen: true });
    }
  }

  onOpenHelp() {
    this.setState({ isOpen: !this.state.isOpen });
  }

  render() {
    const {
      schema: { options, disabled, description },
      error,
    } = this.props;
    const errorMessage = error && error.message;

    // TODO: Add i18n support
    const namesInputs = options.map((option: any) => ({
      label: option.label.ru,
      name: `${option.name}_${getRandomKey()}`,
    }));

    return (
      <Field
        {...this.props.schema}
        status={this.state.value ? 'success' : 'default'}
        helpBtn={
          !isUndefined(description) && (
            <span
              className="btn btn-default btn-circle"
              onClick={this.onOpenHelp}
            >
              <span className="glyphicon glyphicon-question-sign"></span>
            </span>
          )
        }
      >
        <div className="input-group-cr">
          <div className="btn-group">
            {namesInputs.map((option: IRadiobuttonOption, idx: number) => (
              <label key={idx} htmlFor={option.name} className="radio-inline">
                <input
                  type="radio"
                  disabled={disabled}
                  name={option.name}
                  data-value={option.label}
                  checked={option.label === this.state.value}
                  onClick={this.onClick}
                />
                {option.label}
              </label>
            ))}
          </div>
          {/*{ description && (*/}
          {/*     <span className="btn btn-default btn-circle" onClick={this.onOpenHelp} >*/}
          {/*         <span className="glyphicon glyphicon-question-sign"></span>*/}
          {/*    </span>*/}
          {/*) }*/}
        </div>
        {description && this.state.isOpen && (
          <div className="alert alert-warning" role="alert">
            {this.tr(description)}
          </div>
        )}
        {errorMessage && <Alert>{errorMessage}</Alert>}
      </Field>
    );
  }
}

export function createRadiobutton(
  schema: IControlSchema,
  dispatcher: IDispatcher = null,
  error: IControlError | undefined,
  visited: boolean,
): React.ReactElement<any> {
  return (
    <Radiobutton
      schema={schema as IRadiobuttonSchema}
      error={error}
      visited={visited}
      dispatcher={dispatcher}
    />
  );
}
